import LearnMoreAboutOCIInactiveModal from './LearnMoreAboutOCIInactiveModal';

export default LearnMoreAboutOCIInactiveModal;
